<template>
  <div class="myinfo">
    <van-nav-bar :title="title" fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-cell class="head" title="头像" @click="upHeadportrait(userinfo.u_headportrait)">
        <van-image
          width="35px"
          height="35px"
          round
          slot="right-icon"
          class="err-image-header"
          :src="userinfo.u_headportrait.indexOf('http')==-1?(attach_url+userinfo.u_headportrait):userinfo.u_headportrait"
          style="line-height: inherit;"
          is-link
        />
        <van-icon slot="right-icon" name="arrow" style="line-height: inherit;" is-link />
      </van-cell>
      <van-cell title="账号" :value="userinfo.u_login_id" v-if="userinfo.u_upflag" is-link @click="upUserLoginId(userinfo.u_login_id)"/>
      <van-cell title="账号" :value="userinfo.u_login_id" v-else/>
      <van-cell title="邀请码" :value="userinfo.u_code"  is-link @click="copyCode(userinfo.u_code)"/>
      <van-cell
        title="姓名"
        is-link
        v-if="!userinfo.u_name"
        :value="userinfo.u_name?userinfo.u_name:'填写姓名'"
        @click="upName(userinfo.u_name)"
      />
      <van-cell title="姓名" v-else :value="userinfo.u_name" />
      <van-cell
        title="手机号码"
        is-link
        v-if="!userinfo.u_phone"
        :value="userinfo.u_phone?userinfo.u_phone:'填写电话号码'"
        @click="upPhone(userinfo.u_phone)"
      />
      <van-cell title="手机号码" v-else :value="userinfo.u_phone" />
      <van-cell
        title="邮箱"
        is-link
        v-if="!userinfo.u_email"
        :value="userinfo.u_email?userinfo.u_email:'填写邮箱'"
        @click="upEmail(userinfo.u_email)"
      />
      <van-cell title="邮箱" v-else :value="userinfo.u_email" />
      <van-cell
        title="昵称"
        is-link
        :value="userinfo.u_nickname"
        @click="upNickname(userinfo.u_nickname)"
      />
      <van-cell
        @click="showGender=!showGender"
        title="性别"
        is-link
        :value="userinfo.u_sex == '1'?'男':userinfo.u_sex == '2'?'保密':'女'"
      ></van-cell>
      <van-cell
        title="个性签名"
        is-link
        :value="userinfo.u_signature?userinfo.u_signature:'填写个性签名'"
        @click="upSignature(userinfo.u_signature)"
      />
    </van-cell-group>
    <van-popup v-model="showGender" position="bottom">
      <van-picker
        show-toolbar
        title="选择性别"
        :columns="['保密', '男','女']"
        @cancel="showGender = false"
        @confirm="onGenderConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
	name: "MyInfo",
	data() {
		return {
			title: "个人信息修改",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			showGender: false,
			value: "",
			attach_url: this.Conf.serverPre,
			userinfo: JSON.parse(localStorage.getItem("userInfo")),
		};
	},
	created() {
		this.getStateConfigs();
		//console.log(this.userinfo)
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		// 返回
		onClickLeft() {
			this.$router.push({
				name: "My",
				query: {
				}
			});
		},
		upUserLoginId(u_login_id){
			this.$router.push({
				name: "UpInfo",
				query: {
					login_id: u_login_id,
					key: "u_login_id",
					title: "修改账号"
				}
			});
		},
		// 修改头像
		upHeadportrait(u_headportrait) {
			this.$router.push({
				name: "UpInfo",
				query: {
					head: u_headportrait,
					key: "u_headportrait",
					title: "修改头像"
				}
			});
		},
		// 修改名字
		upName(u_name) {
		  this.$router.push({
			name: "UpInfo",
			query: {
			  name: u_name,
			  key: "u_name",
			  title: "修改名字"
			}
		  });
		},
		// 修改手机号码
		upPhone(u_phone) {
		  this.$router.push({
			name: "UpInfo",
			query: {
			  phone: u_phone,
			  key: "u_phone",
			  title: "修改手机号码"
			}
		  });
		},
		// 修改邮箱
		upEmail(u_email) {
		  this.$router.push({
			name: "UpInfo",
			query: {
			  email: u_email,
			  key: "u_email",
			  title: "修改邮箱"
			}
		  });
		},
		// 修改昵称
		upNickname(u_nickname) {
		  this.$router.push({
			name: "UpInfo",
			query: {
			  nickname: u_nickname,
			  key: "u_nickname",
			  title: "修改昵称"
			}
		  });
		},
		onGenderConfirm(value, index) {
		  this.showGender = false;
		  var params = {
			u_id: this.u_id,
			token: this.token,
			key: "u_sex",
			value: index
		  };
		  // var userInfo = JSON.parse(localStorage.getItem("userInfo"));
		  // localStorage.setItem("userInfo", JSON.stringify(params));
		  // console.log("hhh", userInfo);
		  var url = this.Conf.serverUrl + "User/updateUserInfo" + "?num=" + Math.random();
		  this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
			  switch (response.data.code) {
				case 200:
				 //localStorage.setItem("userInfo",JSON.stringify(params));
					var userInfo = JSON.parse(localStorage.getItem("userInfo"));
					userInfo.u_sex = index;
					localStorage.setItem("userInfo", JSON.stringify(userInfo));
					this.userinfo = userInfo;
				  // this.loadData();
				  this.$toast.success(response.data.msg);
				  break;
				case 40001:
				  this.$toast.fail(response.data.msg);
				  break;
			  }
			})
			.catch(error => {});
		},
		// 修改个性签名
		upSignature(u_signature) {
		  this.$router.push({
			name: "UpInfo",
			query: {
			  signature: u_signature,
			  key: "u_signature",
			  title: "修改个性签名"
			}
		  });
		},
		copyCode(code){		
			let that = this;
			this.$copyText(code).then(function (e) {
				that.$toast.success("链接复制成功,去邀请吧！");
			}, function (e) {
				that.$toast.fail("复制失败,请稍候重试！");
			});
		}
	  }
};
</script>





// WEBPACK FOOTER //
// src/components/My/MyInfo.vue